import Macy from 'macy';

export default function() {

  let applyMasonryOnFunctionEntries = () => {
    const functionEntriesMasonrySelector = '.function-entries.masonry-grid';

    let functionMasonry = null;

    if (document.querySelector(functionEntriesMasonrySelector)) {
      functionMasonry = Macy({
        container: '.function-entries.masonry-grid',
        margin: 24,
        columns: 3,
        trueOrder: true,
        breakAt: {
          1400: 2,
          1024: 1,
        },
      });
    }

    document.querySelectorAll('.function-entries .toggle-list').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.currentTarget.closest('.function').classList.toggle('show-more-tags');
        e.currentTarget.classList.toggle('toggle-list-active');
        if (functionMasonry) {
          functionMasonry.recalculate(true);
        }
      });
    });

  }

  if (document.querySelector('.function-entries')) {
    applyMasonryOnFunctionEntries();
  }

}
